import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session/session.service';
import { ModalPrivacyPolicyComponent } from 'src/app/components/dialogs/modal-privacy-policy/modal-privacy-policy.component';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../loading/loading-service.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { LocalStorageService } from 'angular-web-storage';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit {

  @Input() TextoTopo = '';
  @Input() action: any

  @Input() hideMenu!: boolean;
  @Input() hideBackButton!: boolean;

  haveBack!: boolean;

  previus: string[] | undefined;
  urlAnterior: any;
  urlAtual: any;

  constructor(
    public dialog: MatDialog, 
    public route: Router, 
    public session: SessionService, 
    public loader: LoadingService, 
    public navigationHistory: NavigationService,
    private gtmService: GoogleTagManagerService,
    private storage: LocalStorageService,
  ) { 
    this.navigationHistory.startSaveHistory() 
  }

  ngOnInit() {

    this.hideMenu = this.hideMenu ? this.hideMenu : false;
    this.previus=this.navigationHistory.getHistory()
    this.previus.length > 1 ? this.haveBack=true : false;
  }

  isShow = true;
  toggleDisplay() {

    this.isShow = !this.isShow;
    //document.body.style.overflow = !this.isShow ? 'hidden' : 'visible';

  }

  backUrl() {
    this.navigationHistory.goBack();
  }

  openDialogPrivacyPolicy() {

    this.dialog.open(ModalPrivacyPolicyComponent);

  }

  goToLink = function (url: string) {
    window.open(url, "_blank");
  }

  changePassword(){
    const urlTemp = this.route.url.replace(/^\//, "");
    this.storage.set('urlReturn', urlTemp)
    this.route.navigate(['/cadastro/confirmacao/update'])
  }

  redirectUpdate(){
    const urlTemp = this.route.url.replace(/^\//, "");
    this.storage.set('urlReturn', urlTemp)
    this.route.navigate(['/revisao/atualizacao-cadastral'])
  }

  async onPhoneButtonClick() {
    this.gtmService.push({
      event: 'contactSac'
    });
  }



}
  

